import React, { useContext, useState } from "react";
import {
  DataGrid,
  trTR,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import "./AccountingList.css";
import { trTR as coretrTR } from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { paymentMethods } from "shared/util/types";
import { StoreContext } from "shared/context/store-context";

const ExpenceList = (props) => {
  const visibilityJSON = localStorage.getItem("expense_visibility");
  const visibilityModel = visibilityJSON ? JSON.parse(visibilityJSON) : {};
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(visibilityModel);
  const filterJSON = localStorage.getItem("expense_filter");
  const initialFilterModel = filterJSON ? JSON.parse(filterJSON) : { items: [] };
  const [filterModel, setFilterModel] = useState(initialFilterModel);
  const store = useContext(StoreContext);

  const theme = createTheme(
    {
      palette: {
        primary: { main: "#1976d2" },
      },
    },
    trTR,
    coretrTR,
    {
      GridCsvExportOptions: { fileName: "gh" },
    }
  );

  const columns = [
    {
      field: "school",
      headerName: "Kurum",
      width: 300,
      valueGetter: (params) =>
        store.schoolOptions.find((item) => item.value.toString() === params.row.school.toString()).label,
    },

    {
      field: "date",
      headerName: "Ödeme Tarihi",
      width: 200,
      //valueGetter: (params) => store.educationYearsOptions.find((item) => item.value.toString() === params.row.year.toString()).label
    },

    { field: "person", headerName: "Kişi/Kurum", width: 250 },
    { field: "amount", headerName: "Ücret", width: 150 },

    {
      field: "paymentMethod",
      headerName: "Ödeme Yöntemi",
      width: 150,
      valueGetter: (params) =>
        paymentMethods.find((item) => item.value.toString() === params.row.paymentMethod.toString()).label,
    },

    // { field: 'name', headerName: 'Hizmet Adı', width: 300 },
    // { field: 'serviceStartDate', headerName: 'Hizmet Başlangıç Tarihi', width: 200 },
    // { field: 'serviceEndingDate', headerName: 'Hizmet Bitiş Tarihi', width: 200 },
    // { field: 'amount', headerName: 'Meblağ', width: 200 },
  ];

  const OnSelectionChangeHandler = (event) => {
    props.onItemSelect(event[0]);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport csvOptions={{ utf8WithBom: true }} />
      </GridToolbarContainer>
    );
  }

  return (
    <div className="itemListContainer">
      <ThemeProvider theme={theme}>
        <DataGrid
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) => {
            localStorage.setItem("expense_visibility", JSON.stringify(newModel));
            setColumnVisibilityModel(newModel);
          }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => {
            localStorage.setItem("expense_filter", JSON.stringify(newModel));
            setFilterModel(newModel);
          }}
          key={props.items}
          density="compact"
          components={{
            Toolbar: CustomToolbar,
          }}
          rows={props.items}
          columns={columns}
          pageSize={100}
          getRowId={(r) => r.id}
          onSelectionModelChange={OnSelectionChangeHandler}
        />
      </ThemeProvider>
    </div>
  );
};

export default ExpenceList;
